<template>

	<main id="capital">

		<section class="capital-hero">

			<div class="limit-width">

				<div class="capital-hero__content">

					<span>
						{{ 'capital_page_landing' | staticContentAlt }}
					</span>

					<h1>
						{{ 'capital_page_landing' | staticTitle }}
					</h1>

					<vue-marked>
						{{ 'capital_page_landing' | staticContent }}
					</vue-marked>

					<a href="#" class="btn-primary">
						{{ 'capital_page_landing_cta' | staticTitle }}
					</a>

				</div>

				<div class="capital-hero__image">

					<img
						:src="'capital_page_landing' | staticImg"
						alt=""
					>

				</div>

			</div>

		</section>


		<section class="capital-architecture">

			<div class="limit-width">

				<h2>
					{{ 'capital_page_architecture' | staticTitle }}
				</h2>

				<vue-marked>
					{{ 'capital_page_architecture' | staticContent }}
				</vue-marked>

			</div>

		</section>


		<section class="capital-disciplines">

			<div class="limit-width">

				<div class="capital-disciplines__intro">

					<span>
						{{ 'capital_page_disciplines' | staticContentAlt }}
					</span>

					<h2>
						{{ 'capital_page_disciplines' | staticTitle }}
					</h2>

					<vue-marked>
						{{ 'capital_page_disciplines' | staticContent }}
					</vue-marked>

				</div>

				<div class="capital-disciplines__grid">

					<article
						v-for="item in disciplines"
						:key="item"
						class="capital-discipline"
					>

						<span>
							{{ item | staticContentAlt }}
						</span>

						<h3>
							{{ item | staticTitle }}
						</h3>

						<vue-marked>
							{{ item | staticContent }}
						</vue-marked>

					</article>

				</div>

			</div>

		</section>


		<section class="capital-ownership">

			<div class="limit-width">

				<div class="capital-ownership__intro">

					<span>
						{{ 'capital_page_ownership' | staticContentAlt }}
					</span>

					<h2>
						{{ 'capital_page_ownership' | staticTitle }}
					</h2>

					<vue-marked>
						{{ 'capital_page_ownership' | staticContent }}
					</vue-marked>

				</div>

				<div class="capital-ownership__grid">

					<article
						v-for="item in ownershipItems"
						:key="item"
					>

						<h3>
							{{ item | staticTitle }}
						</h3>

						<vue-marked>
							{{ item | staticContent }}
						</vue-marked>

					</article>

				</div>

				<div class="capital-ownership__statement">

					<vue-marked>
						{{ 'capital_page_ownership_statement' | staticContent }}
					</vue-marked>

				</div>

			</div>

		</section>


		<section class="capital-projects">

			<div class="limit-width">

				<div class="capital-projects__intro">

					<span>
						{{ 'capital_page_projects' | staticContentAlt }}
					</span>

					<h2>
						{{ 'capital_page_projects' | staticTitle }}
					</h2>

					<vue-marked>
						{{ 'capital_page_projects' | staticContent }}
					</vue-marked>

				</div>

				<div class="capital-projects__grid">

					<article
						v-for="item in projectItems"
						:key="item"
					>

						<h3>
							{{ item | staticTitle }}
						</h3>

						<vue-marked>
							{{ item | staticContent }}
						</vue-marked>

					</article>

				</div>

			</div>

		</section>


		<section class="capital-lens">

			<div class="limit-width">

				<div class="capital-lens__intro">

					<span>
						{{ 'capital_page_lens' | staticContentAlt }}
					</span>

					<h2>
						{{ 'capital_page_lens' | staticTitle }}
					</h2>

					<vue-marked>
						{{ 'capital_page_lens' | staticContent }}
					</vue-marked>

				</div>

				<div class="capital-lens__steps">

					<article
						v-for="item in lensItems"
						:key="item"
					>

						<h3>
							{{ item | staticTitle }}
						</h3>

						<vue-marked>
							{{ item | staticContent }}
						</vue-marked>

					</article>

				</div>

				<div class="capital-lens__statement">

					<vue-marked>
						{{ 'capital_page_lens_statement' | staticContent }}
					</vue-marked>

				</div>

			</div>

		</section>


		<section class="capital-integration">

			<div class="limit-width">

				<div class="capital-integration__intro">

					<span>
						{{ 'capital_page_integration' | staticContentAlt }}
					</span>

					<h2>
						{{ 'capital_page_integration' | staticTitle }}
					</h2>

					<vue-marked>
						{{ 'capital_page_integration' | staticContent }}
					</vue-marked>

				</div>

				<div class="capital-integration__grid">

					<article
						v-for="item in integrationItems"
						:key="item"
					>

						<h3>
							{{ item | staticTitle }}
						</h3>

						<vue-marked>
							{{ item | staticContent }}
						</vue-marked>

					</article>

				</div>

			</div>

		</section>


		<section class="capital-expertise">

			<div class="limit-width">

				<span>
					{{ 'capital_page_expertise' | staticContentAlt }}
				</span>

				<h2>
					{{ 'capital_page_expertise' | staticTitle }}
				</h2>

				<vue-marked>
					{{ 'capital_page_expertise' | staticContent }}
				</vue-marked>

			</div>

		</section>


		<section class="capital-who">

			<div class="limit-width">

				<div class="capital-who__intro">

					<span>
						{{ 'capital_page_who' | staticContentAlt }}
					</span>

					<h2>
						{{ 'capital_page_who' | staticTitle }}
					</h2>

					<vue-marked>
						{{ 'capital_page_who' | staticContent }}
					</vue-marked>

				</div>

				<div class="capital-who__grid">

					<article
						v-for="item in whoItems"
						:key="item"
					>

						<vue-marked>
							{{ item | staticContent }}
						</vue-marked>

					</article>

				</div>

			</div>

		</section>


		<section class="capital-final-cta">

			<div class="limit-width">

				<div class="capital-final-cta__content">

					<h2>
						{{ 'capital_page_final_cta' | staticTitle }}
					</h2>

					<vue-marked>
						{{ 'capital_page_final_cta' | staticContent }}
					</vue-marked>

				</div>

				<div class="capital-final-cta__actions">

					<a href="#" class="btn-primary">
						{{ 'capital_page_final_cta_primary' | staticTitle }}
					</a>

					<a href="#" class="project__link">
						{{ 'capital_page_final_cta_secondary' | staticTitle }}
					</a>

				</div>

			</div>

		</section>

	</main>

</template>


<script>
export default {

	name: 'Capital',

	data() {

		return {

			disciplines: [
				'capital_page_discipline_1',
				'capital_page_discipline_2',
				'capital_page_discipline_3',
				'capital_page_discipline_4'
			],

			ownershipItems: [
				'capital_page_ownership_item_1',
				'capital_page_ownership_item_2',
				'capital_page_ownership_item_3',
				'capital_page_ownership_item_4',
				'capital_page_ownership_item_5'
			],

			projectItems: [
				'capital_page_projects_item_1',
				'capital_page_projects_item_2',
				'capital_page_projects_item_3',
				'capital_page_projects_item_4',
				'capital_page_projects_item_5',
				'capital_page_projects_item_6',
				'capital_page_projects_item_7',
				'capital_page_projects_item_8',
				'capital_page_projects_item_9'
			],

			lensItems: [
				'capital_page_lens_item_1',
				'capital_page_lens_item_2',
				'capital_page_lens_item_3',
				'capital_page_lens_item_4',
				'capital_page_lens_item_5',
				'capital_page_lens_item_6'
			],

			integrationItems: [
				'capital_page_integration_item_1',
				'capital_page_integration_item_2',
				'capital_page_integration_item_3'
			],

			whoItems: [
				'capital_page_who_item_1',
				'capital_page_who_item_2',
				'capital_page_who_item_3',
				'capital_page_who_item_4',
				'capital_page_who_item_5',
				'capital_page_who_item_6',
				'capital_page_who_item_7'
			]

		}

	}

}
</script>

<style lang="scss">

#capital {
	color: #394455;
	background: #F5F1EB;

	h1,
	h2,
	h3,
	p {
		margin-top: 0;
	}

	.capital-hero {
		padding: 48px 0;
		background: #F5F1EB;

		.limit-width {
			display: grid;
			grid-template-columns: 1fr;
			gap: 35px;
		}

		&__content {
			min-width: 0;

			> span {
				display: block;
				margin-bottom: 12px;

				font-size: .72rem;
				font-weight: 600;
				letter-spacing: .14em;
				text-transform: uppercase;

				color: #D97943;
			}

			h1 {
				max-width: 760px;
				margin-bottom: 22px;

				font-family: "Cormorant Garamond", serif;
				font-size: 2.8rem;
				font-weight: 400;
				line-height: 1;

				color: #1F2B3D;
			}

			p {
				max-width: 680px;
				margin-bottom: 15px;

				font-size: .95rem;
				line-height: 1.75;

				color: #394455;
			}

			strong {
				color: #1F2B3D;
			}

			.btn-primary {
				display: inline-flex;
				margin-top: 18px;
			}
		}

		&__image {
			min-width: 0;
			overflow: hidden;

			img {
				display: block;
				width: 100%;
				height: 420px;

				object-fit: cover;
			}
		}
	}


	.capital-architecture {
		padding: 48px 0;
		background: #ECE8E0;

		.limit-width {
			display: grid;
			grid-template-columns: 1fr;
			gap: 24px;
		}

		h2 {
			max-width: 760px;
			margin-bottom: 0;

			font-family: "Cormorant Garamond", serif;
			font-size: 2.35rem;
			font-weight: 400;
			line-height: 1.05;

			color: #1F2B3D;
		}

		p {
			max-width: 820px;
			margin-bottom: 14px;

			font-size: .95rem;
			line-height: 1.75;
		}

		strong {
			color: #1F2B3D;
		}
	}


	.capital-disciplines {
		padding: 48px 0;
		background: #F5F1EB;

		&__intro {
			max-width: 820px;
			margin-bottom: 32px;

			> span {
				display: block;
				margin-bottom: 10px;

				font-size: .72rem;
				font-weight: 600;
				letter-spacing: .14em;
				text-transform: uppercase;

				color: #D97943;
			}

			h2 {
				margin-bottom: 18px;

				font-family: "Cormorant Garamond", serif;
				font-size: 2.35rem;
				font-weight: 400;
				line-height: 1.05;

				color: #1F2B3D;
			}

			p {
				margin-bottom: 12px;

				font-size: .95rem;
				line-height: 1.75;
			}
		}

		&__grid {
			display: grid;
			grid-template-columns: 1fr;
			gap: 16px;
		}
	}

	.capital-discipline {
		min-width: 0;
		padding: 28px 24px;

		background: #ECE8E0;

		> span {
			display: block;
			margin-bottom: 12px;

			font-size: .7rem;
			font-weight: 600;
			letter-spacing: .14em;
			text-transform: uppercase;

			color: #B45D2D;
		}

		h3 {
			margin-bottom: 15px;

			font-family: "Cormorant Garamond", serif;
			font-size: 1.7rem;
			font-weight: 400;
			line-height: 1.08;

			color: #1F2B3D;
		}

		p,
		li {
			font-size: .9rem;
			line-height: 1.7;
		}

		p {
			margin-bottom: 12px;
		}

		ul {
			margin: 16px 0 0;
			padding-left: 18px;
		}
	}


	.capital-ownership {
		padding: 48px 0;

		background: #1F2B3D;
		color: #fff;

		&__intro {
			max-width: 800px;
			margin-bottom: 32px;

			> span {
				display: block;
				margin-bottom: 10px;

				font-size: .72rem;
				font-weight: 600;
				letter-spacing: .14em;
				text-transform: uppercase;

				color: #D97943;
			}

			h2 {
				margin-bottom: 18px;

				font-family: "Cormorant Garamond", serif;
				font-size: 2.35rem;
				font-weight: 400;
				line-height: 1.05;

				color: #fff;
			}

			p {
				margin-bottom: 12px;

				font-size: .95rem;
				line-height: 1.75;

				color: rgba(255,255,255,.72);
			}
		}

		&__grid {
			display: grid;
			grid-template-columns: 1fr;
			gap: 12px;
		}

		&__grid article {
			min-width: 0;
			padding: 22px;

			background: rgba(255,255,255,.06);

			h3 {
				margin-bottom: 8px;

				font-family: "Cormorant Garamond", serif;
				font-size: 1.45rem;
				font-weight: 400;

				color: #fff;
			}

			p {
				margin-bottom: 0;

				font-size: .88rem;
				line-height: 1.65;

				color: rgba(255,255,255,.68);
			}
		}

		&__statement {
			max-width: 900px;
			margin-top: 32px;
			padding: 26px;

			background: rgba(255,255,255,.06);

			p {
				margin: 0;

				font-family: "Cormorant Garamond", serif;
				font-size: 1.5rem;
				line-height: 1.25;

				color: #fff;
			}

			strong {
				color: #fff;
			}
		}
	}


	.capital-projects {
		padding: 48px 0;
		background: #F5F1EB;

		&__intro {
			max-width: 820px;
			margin-bottom: 30px;

			> span {
				display: block;
				margin-bottom: 10px;

				font-size: .72rem;
				font-weight: 600;
				letter-spacing: .14em;
				text-transform: uppercase;

				color: #D97943;
			}

			h2 {
				margin-bottom: 18px;

				font-family: "Cormorant Garamond", serif;
				font-size: 2.35rem;
				font-weight: 400;
				line-height: 1.05;

				color: #1F2B3D;
			}

			p {
				margin-bottom: 12px;

				font-size: .95rem;
				line-height: 1.75;
			}
		}

		&__grid {
			display: grid;
			grid-template-columns: 1fr;
			gap: 12px;
		}

		&__grid article {
			min-width: 0;
			padding: 20px 22px;

			background: #ECE8E0;

			h3 {
				margin: 0;

				font-family: "Cormorant Garamond", serif;
				font-size: 1.35rem;
				font-weight: 400;
				line-height: 1.15;

				color: #1F2B3D;
			}

			p {
				margin: 8px 0 0;

				font-size: .88rem;
				line-height: 1.65;
			}
		}
	}


	.capital-lens {
		padding: 48px 0;
		background: #ECE8E0;

		&__intro {
			max-width: 800px;
			margin-bottom: 30px;

			> span {
				display: block;
				margin-bottom: 10px;

				font-size: .72rem;
				font-weight: 600;
				letter-spacing: .14em;
				text-transform: uppercase;

				color: #D97943;
			}

			h2 {
				margin-bottom: 18px;

				font-family: "Cormorant Garamond", serif;
				font-size: 2.35rem;
				font-weight: 400;
				line-height: 1.05;

				color: #1F2B3D;
			}

			p {
				margin-bottom: 12px;

				font-size: .95rem;
				line-height: 1.75;
			}
		}

		&__steps {
			display: grid;
			grid-template-columns: 1fr;
			gap: 12px;
		}

		&__steps article {
			min-width: 0;
			padding: 22px;

			background: #F5F1EB;

			h3 {
				margin-bottom: 8px;

				font-family: "Cormorant Garamond", serif;
				font-size: 1.45rem;
				font-weight: 400;

				color: #1F2B3D;
			}

			p {
				margin: 0;

				font-size: .88rem;
				line-height: 1.65;
			}
		}

		&__statement {
			max-width: 900px;
			margin-top: 28px;

			p {
				margin-bottom: 10px;

				font-family: "Cormorant Garamond", serif;
				font-size: 1.45rem;
				line-height: 1.3;

				color: #1F2B3D;
			}
		}
	}


	.capital-integration {
		padding: 48px 0;

		background: #201B1C;
		color: #fff;

		&__intro {
			max-width: 820px;
			margin-bottom: 30px;

			> span {
				display: block;
				margin-bottom: 10px;

				font-size: .72rem;
				font-weight: 600;
				letter-spacing: .14em;
				text-transform: uppercase;

				color: #D97943;
			}

			h2 {
				margin-bottom: 18px;

				font-family: "Cormorant Garamond", serif;
				font-size: 2.35rem;
				font-weight: 400;
				line-height: 1.05;

				color: #fff;
			}

			p {
				margin-bottom: 12px;

				font-size: .95rem;
				line-height: 1.75;

				color: rgba(255,255,255,.7);
			}
		}

		&__grid {
			display: grid;
			grid-template-columns: 1fr;
			gap: 14px;
		}

		&__grid article {
			min-width: 0;
			padding: 24px;

			background: rgba(255,255,255,.055);

			h3 {
				margin-bottom: 10px;

				font-family: "Cormorant Garamond", serif;
				font-size: 1.5rem;
				font-weight: 400;

				color: #fff;
			}

			p {
				margin: 0;

				font-size: .9rem;
				line-height: 1.7;

				color: rgba(255,255,255,.68);
			}
		}
	}


	.capital-expertise {
		padding: 48px 0;
		background: #F5F1EB;

		.limit-width {
			max-width: 980px;
		}

		span {
			display: block;
			margin-bottom: 10px;

			font-size: .72rem;
			font-weight: 600;
			letter-spacing: .14em;
			text-transform: uppercase;

			color: #D97943;
		}

		h2 {
			max-width: 760px;
			margin-bottom: 20px;

			font-family: "Cormorant Garamond", serif;
			font-size: 2.35rem;
			font-weight: 400;
			line-height: 1.05;

			color: #1F2B3D;
		}

		p {
			max-width: 900px;
			margin-bottom: 14px;

			font-size: .95rem;
			line-height: 1.75;
		}
	}


	.capital-who {
		padding: 48px 0;
		background: #ECE8E0;

		&__intro {
			max-width: 800px;
			margin-bottom: 30px;

			> span {
				display: block;
				margin-bottom: 10px;

				font-size: .72rem;
				font-weight: 600;
				letter-spacing: .14em;
				text-transform: uppercase;

				color: #D97943;
			}

			h2 {
				margin-bottom: 18px;

				font-family: "Cormorant Garamond", serif;
				font-size: 2.35rem;
				font-weight: 400;
				line-height: 1.05;

				color: #1F2B3D;
			}

			p {
				margin-bottom: 12px;

				font-size: .95rem;
				line-height: 1.75;
			}
		}

		&__grid {
			display: grid;
			grid-template-columns: 1fr;
			gap: 12px;
		}

		&__grid article {
			min-width: 0;
			padding: 20px 22px;

			background: #F5F1EB;

			p {
				margin: 0;

				font-size: .9rem;
				line-height: 1.65;

				color: #394455;
			}

			strong {
				color: #1F2B3D;
			}
		}
	}


	.capital-final-cta {
		padding: 48px 0;
		background: #1F2B3D;
		color: #fff;

		.limit-width {
			display: grid;
			grid-template-columns: 1fr;
			gap: 28px;
		}

		&__content {
			min-width: 0;

			h2 {
				max-width: 760px;
				margin-bottom: 20px;

				font-family: "Cormorant Garamond", serif;
				font-size: 2.6rem;
				font-weight: 400;
				line-height: 1;

				color: #fff;
			}

			p {
				max-width: 760px;
				margin-bottom: 12px;

				font-size: .95rem;
				line-height: 1.75;

				color: rgba(255,255,255,.72);
			}
		}

		&__actions {
			display: flex;
			flex-direction: column;
			align-items: flex-start;
			gap: 18px;
		}

		.project__link {
			color: #fff;
		}
	}
}


@media (min-width: 768px) {

	#capital {

		.capital-hero,
		.capital-architecture,
		.capital-disciplines,
		.capital-ownership,
		.capital-projects,
		.capital-lens,
		.capital-integration,
		.capital-expertise,
		.capital-who,
		.capital-final-cta {
			padding: 58px 0;
		}

		.capital-hero {

			&__content h1 {
				font-size: 3.7rem;
			}

			&__image img {
				height: 500px;
			}
		}

		.capital-architecture h2,
		.capital-disciplines__intro h2,
		.capital-ownership__intro h2,
		.capital-projects__intro h2,
		.capital-lens__intro h2,
		.capital-integration__intro h2,
		.capital-expertise h2,
		.capital-who__intro h2 {
			font-size: 3rem;
		}

		.capital-disciplines__grid {
			grid-template-columns: repeat(2, minmax(0, 1fr));
		}

		.capital-ownership__grid {
			grid-template-columns: repeat(2, minmax(0, 1fr));
		}

		.capital-projects__grid {
			grid-template-columns: repeat(2, minmax(0, 1fr));
		}

		.capital-lens__steps {
			grid-template-columns: repeat(2, minmax(0, 1fr));
		}

		.capital-integration__grid {
			grid-template-columns: repeat(3, minmax(0, 1fr));
		}

		.capital-who__grid {
			grid-template-columns: repeat(2, minmax(0, 1fr));
		}

		.capital-final-cta {

			&__content h2 {
				font-size: 3.2rem;
			}

			&__actions {
				flex-direction: row;
				align-items: center;
				gap: 26px;
			}
		}
	}
}


@media (min-width: 1100px) {

	#capital {

		.capital-hero,
		.capital-architecture,
		.capital-disciplines,
		.capital-ownership,
		.capital-projects,
		.capital-lens,
		.capital-integration,
		.capital-expertise,
		.capital-who,
		.capital-final-cta {
			padding: 68px 0;
		}

		.capital-hero {

			.limit-width {
				grid-template-columns:
					minmax(0, 1.05fr)
					minmax(380px, .95fr);

				gap: 75px;
				align-items: center;
			}

			&__content h1 {
				font-size: 4.5rem;
			}

			&__image img {
				height: 610px;
			}
		}

		.capital-architecture {

			.limit-width {
				grid-template-columns: minmax(0, .75fr) minmax(0, 1.25fr);
				gap: 75px;
				align-items: start;
			}

			h2 {
				font-size: 3.3rem;
			}
		}

		.capital-disciplines {

			&__intro {
				margin-bottom: 38px;
			}

			&__intro h2 {
				font-size: 3.3rem;
			}

			&__grid {
				gap: 18px;
			}
		}

		.capital-discipline {
			padding: 34px 32px;
		}

		.capital-ownership {

			&__intro h2 {
				font-size: 3.3rem;
			}

			&__grid {
				grid-template-columns: repeat(5, minmax(0, 1fr));
			}

			&__grid article {
				padding: 24px 20px;
			}

			&__statement {
				margin-top: 38px;
				padding: 32px 36px;

				p {
					font-size: 1.75rem;
				}
			}
		}

		.capital-projects {

			&__intro h2 {
				font-size: 3.3rem;
			}

			&__grid {
				grid-template-columns: repeat(3, minmax(0, 1fr));
				gap: 14px;
			}

			&__grid article {
				padding: 24px;
			}
		}

		.capital-lens {

			&__intro h2 {
				font-size: 3.3rem;
			}

			&__steps {
				grid-template-columns: repeat(6, minmax(0, 1fr));
			}

			&__steps article {
				padding: 22px 18px;
			}

			&__statement {
				margin-top: 36px;

				p {
					font-size: 1.6rem;
				}
			}
		}

		.capital-integration {

			&__intro h2 {
				font-size: 3.3rem;
			}

			&__grid article {
				padding: 30px;
			}
		}

		.capital-expertise {

			h2 {
				font-size: 3.3rem;
			}
		}

		.capital-who {

			&__intro h2 {
				font-size: 3.3rem;
			}

			&__grid {
				grid-template-columns: repeat(3, minmax(0, 1fr));
				gap: 14px;
			}

			&__grid article {
				padding: 24px;
			}
		}

		.capital-final-cta {

			.limit-width {
				grid-template-columns: minmax(0, 1.15fr) minmax(300px, .85fr);
				gap: 80px;
				align-items: center;
			}

			&__content h2 {
				font-size: 3.8rem;
			}

			&__actions {
				justify-content: flex-end;
			}
		}
	}
}

</style>